<script>
export default {
  name: 'RoundedBox',

  props: {
    fullscreen: {
      // Minimum height fills screens
      type: Boolean,
      default: false,
    },
    expandWide: {
      // On larger screens, card can get wider to better show content
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    h1: {
      type: Boolean,
      default: false,
    },
    h2: {
      type: Boolean,
      default: false,
    },
    h3: {
      type: Boolean,
      default: false,
    },
    centerTitle: {
      type: Boolean,
      default: false,
    },
    underline: {
      type: Boolean,
      default: false,
    },
    centerContent: {
      type: Boolean,
      default: false,
    },
    marginBetween: {
      type: String,
      default: '6', // Based on Vuetify spacers
    },
    justifyStart: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <v-sheet
    elevation="3"
    class="rounded-box"
    :class="{
      fullscreen,
      'center-content': centerContent,
      'expand-wide': expandWide,
      'justify-start': justifyStart,
    }"
  >
    <div
      v-if="title"
      :class="['card-header', { 'center-title': centerTitle }, `mb-${marginBetween}`]"
    >
      <v-skeleton-loader
        v-if="title === 'loading'"
        type="heading"
        width="100%"
        class="card-title d-flex justify-center"
      >
      </v-skeleton-loader>

      <h1 v-else-if="h1">
        {{ title }}
      </h1>

      <h2 v-else-if="h2">
        {{ title }}
      </h2>

      <h3 v-else>
        {{ title }}
      </h3>

      <p v-if="subtitle" class="subtitle mt-1">
        {{ subtitle }}
      </p>

      <hr v-if="underline" class="header-underline mb-0" />
    </div>

    <slot />
  </v-sheet>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.rounded-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  margin: 4px auto 16px auto;
  padding: 24px;
  background-color: white;

  // For last card, make sure enough padding to accomodate notches
  &:last-child {
    margin-bottom: calc(16px + var(--safe-area-inset-bottom));
  }

  &.center-content {
    align-items: center;
  }

  .app & {
    max-width: 360px;
  }

  .admin & {
    min-height: 620px;
  }

  .sm & {
    max-width: 420px;
  }

  &.fullscreen {
    position: absolute;
    // width: 360px;

    .app & {
      position: relative;
      min-height: 660px;
      max-height: fit-content;

      .sm & {
        position: relative;
        min-height: calc(100vh - (#{$top-bar-height}) - 16px - 4px - var(--safe-area-inset-bottom));
        height: fit-content;
      }
    }
  }

  &.expand-wide {
    .md &,
    .lg &,
    .xl & {
      min-width: 360px;
      width: 60%;
      max-width: 720px;
      padding: 2rem;
    }
  }
}

.card-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  h1,
  h2,
  h3,
  p {
    margin: 0;
  }

  &.center-title {
    align-items: center;
    text-align: center;
  }
}
</style>
